module.exports = __webpack_public_path__ + "static/media/4.8a1e436b.jpg";